<template>
  <div class="footer2">
    <div class="footer2btn">
      预估费用{{price}}
      <van-button class="footerbtn" :loading="loading" loading-text="下单中..." type="danger" @click="subOrder">下单</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer2',
  data() {
    return{
      loading: false,
      price: ''
    }
  },
  methods: {
    setLoading() {
      this.loading = true
    },
    closeLoading() {
      this.loading = false
    },
    setPrice(price) {
      this.price = price
    },
    subOrder() {
      this.$emit('subOrder')
    }
  }
}
</script>

<style lang="less" scoped>
.footer2{
  width: 100%;
  height: 160px;
  background: #FFFFFF;
  box-shadow: 0px 1px 48px 2px rgba(224,224,224,0.41);
  position:fixed;
  bottom:0px;
  z-index:2;
  padding-top:20px;
  .footer2btn{
    width: 680px;
    height: 79px;
    background: #000000;
    border-radius: 40px;
    border: 0px solid #F099BA;
    margin:0px auto;
    font-weight: 400;
    font-size: 30px;
    color: #FFFFFF;
    padding-left:40px;
    line-height: 79px;
    .footerbtn{
      float:right;
      width: 193px;
      height: 79px;
      background: #E60012;
      border-radius: 40px;
      border: 0px solid #F099BA;
      font-weight: 400;
      font-size: 30px;
      color: #FFFFFF;
      line-height: 49px;
    }
  }
}
</style>
